import type {
  ReactElement,
} from 'react';

import type {
  HeaderMenuCustomParams,
} from '../types';

export function HeaderMenuCustomItem({
  component: CustomComponent,
  text = undefined,
  ...rest
}: HeaderMenuCustomParams): ReactElement {
  return (
    <CustomComponent
      {...rest}
    >
      {text}
    </CustomComponent>
  );
}
